module.exports = __webpack_public_path__ + "img/barcode.2b7b50be.svg";